// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1xNZR","content":"LoadingAlert_content__2CSGd"};